var _metadata, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72.700279mm",
    height: "72.700447mm",
    viewBox: "0 0 72.700279 72.700447",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata14"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    guidetolerance: 10,
    gridtolerance: 10,
    objecttolerance: 10,
    borderopacity: 1,
    bordercolor: "#666666",
    pagecolor: "#ffffff"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath884"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59.636053,49.153011 A 34.34354,34.34354 0 0 1 22.503303,80.356224 34.34354,34.34354 0 0 1 -8.8017306,43.309274 34.34354,34.34354 0 0 1 28.159141,11.902656 34.34354,34.34354 0 0 1 59.667106,48.77717",
    id: "path886",
    style: {
      fill: "#acf1f1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 0.25,
      paintOrder: "stroke fill markers"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(10.956094,-10.162906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath884)",
    id: "g859"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 7.00008,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M -12.122452,65.17801 17.368194,20.382094 50.181377,77.216191",
    id: "path851"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 33.980014,47.632941 9.042394,-13.34072 26.569067,46.018974",
    id: "path855"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 59.604999,49.528854 A 34.34354,34.34354 0 0 1 22.472249,80.732067 34.34354,34.34354 0 0 1 -8.8327841,43.685117 34.34354,34.34354 0 0 1 28.128087,12.278499 34.34354,34.34354 0 0 1 59.636052,49.153013",
    id: "path849",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 4.01029,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.98374,
      paintOrder: "stroke fill markers"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a27db97e2c9e70a4efe8ab6cf844635.svg";
export { ForwardRef as ReactComponent };